
import { Button } from 'primereact/button';
import React, { useEffect } from 'react';
import Joyride, { TooltipRenderProps } from 'react-joyride';
import { Icons } from './Icons/Icons';
import { JournalViewModel } from '../../../ViewModel/JournalViewModel';
import { GLStep } from '../../../ViewModel/TutorialStateViewModel';
import { useLocation, useNavigate } from 'react-router';

export function Tutorial({ journalViewModel }: { journalViewModel: JournalViewModel }) {

    const navigate = useNavigate();
    const { pathname } = useLocation();
    const stateVM = journalViewModel.TutorialState;
    const [run, setRun] = React.useState<boolean>(stateVM.TypedData.isRunning);
    const [stepIndex, setStepIndex] = React.useState<number>(stateVM.TypedData.stepIndex);
    const [steps, setSteps] = React.useState<GLStep[]>(stateVM.steps);

    //
    // Handle the mounting of the component.
    //
    useEffect(() => {
        const onPropertyChanged = () => {
            setRun(stateVM.TypedData.isRunning);
            setStepIndex(stateVM.TypedData.stepIndex);
            setSteps(stateVM.steps);
        };

        stateVM.PropertyChanged.Subscribe(onPropertyChanged);

        return () => {
            stateVM.PropertyChanged.Unsubscribe(onPropertyChanged);
        };
    }, []);


    if (!stateVM.TypedData.isRunning)
        return <></>;

    stateVM.navigateFunction = { navigate: navigate, pathname: pathname };
    const currentStep = stateVM.steps[stateVM.TypedData.stepIndex];
    const removeOffset = currentStep.placement === 'center';
    const borderRadius = currentStep.borderRadius ?? '1rem';

    return (
        <Joyride
            steps={steps}
            continuous={true}
            showSkipButton={true}
            run={run}
            stepIndex={stepIndex}
            scrollToFirstStep={false}
            disableScrolling={true}


            floaterProps={{
                disableAnimation: true,
                placement: 'bottom',
                styles: {
                    arrow: {
                        spread: 1,
                        length: 25
                    },
                    floater: {
                        width: '100%',
                        borderRadius: '1rem'
                    },
                    container: {
                        backgroundColor: 'yellow'
                    },
                    content: {
                        backgroundColor: 'yellow'
                    },
                    wrapper: {
                        backgroundColor: 'red'
                    }
                }
            }}

            callback={stateVM.onCallback}

            tooltipComponent={(props: TooltipRenderProps) => {
                return (
                    <div
                        style={{
                            width: 'calc(100%)',
                        }}
                    >
                        <div style={{
                            backgroundColor: '#F5EDE0',
                            marginLeft: '1rem',
                            marginRight: '1rem',
                            paddingTop: '1.5rem',
                            paddingBottom: '1.5rem',
                            paddingLeft: '1.375rem',
                            paddingRight: '1.375rem',
                            borderRadius: '1rem',
                            textAlign: 'left',
                            transform: removeOffset ? undefined : 'translateX(10px)',
                        }}>
                            <div className='flex flex-row justify-content-start align-items-center'>
                                <Icons.TitleIcon />
                                <h3 className='gl-home-section-title m-0'>{props.step.title}</h3>
                            </div>
                            <div className='gl-dailyscore-label-typography text-left'>{props.step.content}</div>
                            <div
                                className='flex flex-row h-full justify-content-between align-items-center'
                                style={{
                                    marginTop: '1.5rem'
                                }}
                            >
                                <div className='gl-progress gl-dailyscore-label-typography'>{`${props.index + 1} of ${props.size}`}</div>
                                <div className='gl-buttons flex flex-row'>
                                    <Button
                                        {...props.skipProps}
                                        style={{
                                            marginRight: '.675rem',
                                            display: 'flex',
                                            width: '5.25rem',
                                            height: '31px',
                                            gap: '3px',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            flexShrink: 0,

                                            borderRadius: '2rem',
                                            border: '0.2px #fff',
                                            background: 'var(--Brand-green, #fff)',
                                            boxShadow: '0px 3px 10px 3px rgba(0, 0, 0, 0.12)',
                                            outline: 'none',

                                            color: 'var(--Copy-core, #4E2B10)',
                                            textAlign: 'center',
                                            fontFamily: '"Helvetica Neue"',
                                            fontSize: '14px',
                                            fontStyle: 'normal',
                                            fontWeight: 400,
                                            lineHeight: '22px', // or you could use lineHeight: 1.57143 depending on your needs
                                            letterSpacing: '-0.408px',
                                        }}
                                        onClick={stateVM.exitTutorial}
                                    >Skip</Button>
                                    <Button
                                        {...props.primaryProps}
                                        style={{
                                            display: 'flex',
                                            width: '5.25rem',
                                            height: '31px',
                                            gap: '3px',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            flexShrink: 0,

                                            borderRadius: '2rem',
                                            border: '0.2px #fff',
                                            background: 'var(--Brand-green, #669E72)',
                                            boxShadow: '0px 3px 10px 3px rgba(0, 0, 0, 0.12)',
                                            outline: 'none',
                                        }}
                                    >{props.isLastStep ? 'Finish' : 'Next'}</Button>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }}


            styles={{
                options: {
                    overlayColor: 'rgba(0, 0, 0, 0.77)',
                    textColor: '#4E2B10',
                },
                spotlight: {
                    borderRadius: borderRadius,
                    border: '2px solid var(--Brand-green, #669E72)'
                }

            }}
            spotlightPadding={10}

        />
    );
}